import React from 'react';
import { BP_CARD_CLASSES, BP_FIGURE_TITLE_CLASSES } from './brandPresenceClasses';

/**
 * One figure in a card on the Brand Presence screens: what the figure is called, in the typewriter
 * face, above whatever shows it — a value, a value and a note, badges. The card declares no width or
 * height of its own; placement comes in through `className`.
 */
export function BrandPresenceFigureCard(props: { title: React.ReactNode; className?: string; children: React.ReactNode }) {
  return (
    <div
      className={`${BP_CARD_CLASSES} p-5 transition-shadow duration-200 hover:shadow-card-hover${props.className ? ` ${props.className}` : ''}`}
    >
      <p className={`mb-3 ${BP_FIGURE_TITLE_CLASSES}`}>{props.title}</p>
      {props.children}
    </div>
  );
}
